/* SOYMOD #101297 (27/4/26) - */
document.addEventListener('DOMContentLoaded', () => {
  // 1. Comprobar que estamos en la página correcta (body con la clase específica)
  if (document.body.classList.contains('content-page-reserva-consulta')) {
    
    // 2. Buscar el enlace (botón) dentro de #MainContent
    const botonScroll = document.querySelector('#MainContent a[href="#ContactForm"], #MainContent a[href="#apntly-embed-widget-container-id"]'); /* SOYMOD #103773 (22/06/2026) – Añadido selector "#MainContent a[href="#apntly-embed-widget-container-id"]" */

    if (botonScroll) {
      botonScroll.addEventListener('click', (e) => {
        e.preventDefault();

        /* SOYMOD #103773 (22/06/2026) - Selecciona el formulario destino (ContactForm o widget Apntly) según el enlace pulsado, para que el scroll funcione con ambos formularios */
        // // 3. Buscar el elemento cuyo ID empiece por ContactForm
        // const formBase = document.querySelector('[id^="ContactForm"]');
        //
        // if (formBase) {
        //   // 4. Obtener el abuelo del formulario (parent parent)
        //   const targetElement = formBase.parentElement.parentElement;
        //
        //   // 5. Calcular la altura del header
        //   const header = document.querySelector('header.header-section');
        //   const headerHeight = header ? header.offsetHeight : 0;
        //
        //   // 6. Calcular la posición y realizar el scroll suave
        //   const elementPosition = targetElement.getBoundingClientRect().top;
        //   const offsetPosition = elementPosition + window.scrollY - headerHeight;
        //
        //   window.scrollTo({
        //     top: offsetPosition,
        //     behavior: 'smooth'
        //   });
        // }
        // 3. Determinar el formulario destino según el enlace pulsado
        const href = botonScroll.getAttribute('href');
        let targetElement = null;

        if (href === '#apntly-embed-widget-container-id') {
          // Formulario del widget Apntly: el propio contenedor es el destino
          formBase = document.querySelector('#apntly-embed-widget-container-id');
          if (formBase) {
            targetElement = formBase.parentElement.parentElement;
          }
        } else {
          // Formulario de contacto: usar el abuelo del elemento ContactForm
          const formBase = document.querySelector('[id^="ContactForm"]');
          if (formBase) {
            targetElement = formBase.parentElement.parentElement;
          }
        }

        if (targetElement) {
          // 5. Calcular la altura del header
          const header = document.querySelector('header.header-section');
          const headerHeight = header ? header.offsetHeight : 0;

          // 6. Calcular la posición y realizar el scroll suave
          const elementPosition = targetElement.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.scrollY - headerHeight;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
        /* End MOD */
      });
    }
  }
});
/* End MOD */

/* SOYMOD #103478 (25/05/2026) - Descripción desplegable en móvil */
document.addEventListener('click', function (event) {
  var button = event.target.closest('.soy_collapse_toggle');
  if (!button) return;

  var expanded = button.getAttribute('aria-expanded') === 'true';
  button.setAttribute('aria-expanded', String(!expanded));

  var container = button.previousElementSibling;
  if (container && container.classList.contains('soy_collapsed')) {
    container.classList.toggle('soy_collapsed--open');
  }
});

/* End MOD */

/* SOYMOD #103773 (22/06/2026) - Nuevo bloque: detecta el iframe del widget Apntly (puede inyectarse por JS, por eso MutationObserver) e inyecta CSS dentro para mostrar sólo España, Reino Unido, Portugal y Francia en el selector de prefijo telefónico */
(function () {
  const IFRAME_SELECTOR = '#apntly-booking-iframe';
  const STYLE_ID = 'soymod-103773-filtro-paises';

  /* SOYMOD #103773 (26/06/2026) - Correo y teléfono opcionales. */
  const EMAIL_POR_DEFECTO = 'sincorreo@sincorreo.com';
  const TELEFONO_POR_DEFECTO = '123456789';
  /* End MOD */

  /* SOYMOD #103773 (01/07/2026) (1/4) - Desactivada la traducción de textos: la
     página de "Pregunta adicional" ya no se va a mostrar, así que no hace falta
     traducir. Se comenta el código original (antes SOYMOD #103773 26/06/2026). */
  // const TRADUCCIONES = [
  //   {
  //     es: '¿Deseas añadir algún comentario adicional?',
  //     en: 'Would you like to add any additional comments?',
  //     pt: 'Desejas adicionar algum comentário adicional?',
  //     fr: 'Souhaitez-vous ajouter un commentaire supplémentaire ?'
  //   }
  // ];
  /* End MOD */

  // CSS a inyectar DENTRO del iframe. Es un iframe srcdoc → mismo origin que la
  // página, así que podemos acceder a su documento. Oculta todos los items del
  // desplegable de países salvo los permitidos, identificados por la clase de su
  // bandera: España (es), Reino Unido (gb), Portugal (pt) y Francia (fr).
  // Se usa :not(:has(...)), soportado en navegadores modernos.
  const CSS = `
    .vti__dropdown-list .vti__dropdown-item:not(:has(.vti__flag.es, .vti__flag.gb, .vti__flag.pt, .vti__flag.fr)) {
      display: none !important;
    }

    #variant-container {
      display: none;
    }
    /* End MOD */
  `;

  /* SOYMOD #104897 (09/07/2026) (1/4) - Código de Google Tag Manager (GTM-KQZ2MN8L) a inyectar DENTRO del iframe del widget: el <script> va al <head> y el <noscript> al inicio del <body>. */
  const GTM_ID = 'soymod-104897-gtm'; // id del <script> inyectado; guard de idempotencia por documento

  const JS = `
    <!-- Google Tag Manager -->
    <script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-KQZ2MN8L');</script>
    <!-- End Google Tag Manager -->
  `;

  const NOSCRIPT = `
    <!-- Google Tag Manager (noscript) -->
    <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KQZ2MN8L"
    height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
    <!-- End Google Tag Manager (noscript) -->
  `;
  /* End MOD */

  // Inyecta el <style> en el <head> del documento del iframe. Devuelve true si
  // se inyectó (o ya estaba), false si el documento aún no es accesible/listo.
  function inyectarCss(iframe) {
    let doc;
    try {
      doc = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);
    } catch (e) {
      return false; // cross-origin: sin acceso al documento interno
    }
    if (!doc || !doc.head) return false;
    if (doc.getElementById(STYLE_ID)) return true; // ya inyectado en ESTE documento

    const style = doc.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    doc.head.appendChild(style);
    return true;
  }

  /* SOYMOD #104897 (09/07/2026) (2/4) - Inyecta Google Tag Manager DENTRO del documento del iframe: el <script> en el <head> (recreado como elemento real, porque innerHTML no ejecuta los <script>) y el <noscript> al inicio del <body>. Idempotente por documento (guard GTM_ID). Devuelve true si se inyectó o ya estaba, false si el documento aún no es accesible/listo. */
  function inyectarGtm(iframe) {
    let doc;
    try {
      doc = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);
    } catch (e) {
      return false; // cross-origin: sin acceso al documento interno
    }
    if (!doc || !doc.head || !doc.body) return false;
    if (doc.getElementById(GTM_ID)) return true; // ya inyectado en ESTE documento

    // 1) <script> de GTM en el <head>. innerHTML NO ejecuta los <script>: extraemos
    //    el/los <script> del string JS y los recreamos con createElement (un <script>
    //    creado y añadido al DOM sí se ejecuta). Corre en el contexto del iframe, así
    //    que window/document dentro del snippet son los del propio widget.
    const tmp = doc.createElement('div');
    tmp.innerHTML = JS;
    const scripts = tmp.querySelectorAll('script');
    for (let i = 0; i < scripts.length; i++) {
      const s = doc.createElement('script');
      if (i === 0) s.id = GTM_ID; // marca de idempotencia
      if (scripts[i].src) s.src = scripts[i].src;
      else s.textContent = scripts[i].textContent;
      doc.head.appendChild(s);
    }

    // 2) <noscript> de respaldo al INICIO del <body>. insertAdjacentHTML parsea bien
    //    el <noscript> (su iframe sólo se muestra si el navegador tiene JS desactivado).
    doc.body.insertAdjacentHTML('afterbegin', NOSCRIPT);

    return true;
  }
  /* End MOD */

  // El iframe arranca con un documento about:blank que luego es reemplazado por
  // el de srcdoc; inyectar en el blank no sirve (se descarta al cargar el real).
  function docRealCargado(iframe) {
    try {
      const win = iframe.contentWindow;
      const href = win && win.location ? win.location.href : '';
      return !!href && href !== 'about:blank';
    } catch (e) {
      return false;
    }
  }

  // Procesa el iframe: deja un listener que reinyecta en CADA (re)carga del
  // documento, e inyecta ya si el documento real está cargado.
  function procesarIframe(iframe) {
    if (iframe.dataset.soymodObservado === 'ok') return; // listener ya registrado
    iframe.dataset.soymodObservado = 'ok';

    // Reinyecta en cada load: el documento inicial about:blank se reemplaza por
    // el de srcdoc y eso borra cualquier <style> que hubiéramos inyectado antes.
    iframe.addEventListener('load', function () {
      inyectarCss(iframe);
      inyectarGtm(iframe); /* SOYMOD #104897 (09/07/2026) (3/4) - inyecta GTM en cada (re)carga del iframe (el srcdoc borra lo inyectado al recargar) */
      observarFormulario(iframe); // SOYMOD #103773 (26/06/2026) - relleno email opcional
    });

    // Si el documento real ya está cargado (el load pudo dispararse antes de
    // registrar el listener), inyectamos ahora; si sigue en about:blank, esperamos.
    if (docRealCargado(iframe)) {
      inyectarCss(iframe);
      inyectarGtm(iframe); /* SOYMOD #104897 (09/07/2026) (4/4) - inyecta GTM si el doc real ya está cargado */
      observarFormulario(iframe); // SOYMOD #103773 (26/06/2026) - relleno email opcional
    }
  }

  /* SOYMOD #103773 (26/06/2026) - Lógica de correo/teléfono opcionales ------------ */

  // Los campos se localizan POR POSICIÓN (el widget está en 4 idiomas: es/gb/pt/fr,
  // no podemos depender del texto de la etiqueta). Orden del formulario:
  //   0 -> Nombre (obligatorio), 1 -> Correo, 2 -> Teléfono.
  const POS_CAMPO_NOMBRE = 0;
  const POS_CAMPO_EMAIL = 1;
  const POS_CAMPO_TELEFONO = 2;

  // Devuelve el <input> del campo indicado por posición. Cada campo va tras su
  // <p class="question-text">. El de teléfono es un vue-tel-input: su <input> va
  // DENTRO de un contenedor, no como hermano directo; por eso, además del hermano
  // <input>, miramos dentro del contenedor siguiente.
  function buscarInputCampo(doc, pos) {
    const etiquetas = doc.querySelectorAll('p.question-text');
    const etiqueta = etiquetas[pos];
    if (!etiqueta) return null;
    let n = etiqueta.nextElementSibling;
    while (n) {
      if (n.tagName === 'INPUT') return n;
      if (n.classList && n.classList.contains('question-text')) break; // siguiente pregunta
      const dentro = n.querySelector && n.querySelector('input');
      if (dentro) return dentro;
      n = n.nextElementSibling;
    }
    return null;
  }

  // El botón "Reservar ahora" es el ÚLTIMO botón de la barra de acciones (el
  // primero es "Volver"). Lo localizamos por posición, no por texto (4 idiomas).
  function buscarBotonReservar(doc) {
    const cont = doc.querySelector('.customer-details-questions-button-container');
    if (!cont) return null;
    const botones = cont.querySelectorAll('button');
    if (botones.length) return botones[botones.length - 1];
    return cont.lastElementChild;
  }

  // Asigna un valor al input de forma que Vue lo registre: setter nativo + eventos
  // input/change (así su validación interna ve el campo como relleno).
  function setValorReactivo(doc, input, valor) {
    if (!input) return;
    const win = doc.defaultView || window;
    const proto = win.HTMLInputElement && win.HTMLInputElement.prototype;
    const setter = proto && Object.getOwnPropertyDescriptor(proto, 'value').set;
    if (setter) setter.call(input, valor);
    else input.value = valor;
    input.dispatchEvent(new win.Event('input', { bubbles: true }));
    input.dispatchEvent(new win.Event('change', { bubbles: true }));
  }

  // Oculta el campo (su caja .answer-text y su etiqueta) con visibility:hidden, que
  // no provoca salto de layout. Se usa justo antes de inyectar el valor por defecto
  // para que el usuario no vea aparecer el texto al pulsar "Reservar ahora".
  function ocultarCampo(input) {
    const caja = (input.closest && input.closest('.answer-text')) || input;
    caja.style.visibility = 'hidden';
    let etiqueta = caja.previousElementSibling;
    while (etiqueta && !(etiqueta.classList && etiqueta.classList.contains('question-text'))) {
      etiqueta = etiqueta.previousElementSibling;
    }
    if (etiqueta) etiqueta.style.visibility = 'hidden';
  }

  // Rellena con el valor por defecto SOLO los campos (correo/teléfono) que estén
  // vacíos. Se llama justo al pulsar "Reservar ahora", para que el envío lleve
  // datos sin haber mostrado nunca el valor por defecto al usuario. Antes de
  // rellenar cada campo vacío lo ocultamos, para que no se vea cómo se rellena.
  function rellenarVaciosParaEnvio(doc) {
    const email = buscarInputCampo(doc, POS_CAMPO_EMAIL);
    if (email && (email.value || '').trim() === '') {
      ocultarCampo(email);
      setValorReactivo(doc, email, EMAIL_POR_DEFECTO);
    }
    const tel = buscarInputCampo(doc, POS_CAMPO_TELEFONO);
    if (tel && (tel.value || '').trim() === '') {
      ocultarCampo(tel);
      setValorReactivo(doc, tel, TELEFONO_POR_DEFECTO);
    }
  }

  // Activa/desactiva el botón "Reservar ahora" según NUESTRA regla: activo solo si
  // hay Nombre Y al menos un contacto (correo o teléfono, o ambos).
  // GESTIONAMOS el estado completo (activar Y desactivar), no solo activar: al
  // forzar disabled=false, Vue se desincroniza (su virtual DOM sigue creyendo que
  // el botón debe estar deshabilitado, porque su regla exige correo Y teléfono) y
  // NO lo vuelve a deshabilitar al vaciar el campo. Por eso fijamos nosotros el
  // estado en cada evaluación.
  function actualizarBoton(doc) {
    const boton = buscarBotonReservar(doc);
    if (!boton) return;
    const valor = function (pos) {
      const input = buscarInputCampo(doc, pos);
      return input ? (input.value || '').trim() : '';
    };
    const nombreOk = valor(POS_CAMPO_NOMBRE) !== '';
    const contactoOk = valor(POS_CAMPO_EMAIL) !== '' || valor(POS_CAMPO_TELEFONO) !== '';
    const activar = nombreOk && contactoOk;
    if (activar && boton.disabled) {
      boton.disabled = false;
      boton.removeAttribute('disabled');
    } else if (!activar && !boton.disabled) {
      boton.disabled = true;
      boton.setAttribute('disabled', '');
    }
  }

  /* SOYMOD #103773 (01/07/2026) (2/4) - Desactivadas las funciones de traducción
     (idiomaTienda / traducirTextos): la página de "Pregunta adicional" ya no se
     muestra. Se comenta el código original (antes SOYMOD #103773 26/06/2026). */
  // // Idioma de la tienda (página padre). Normaliza p.ej. "es-ES" -> "es". Si no es
  // // uno de los 4 idiomas soportados, usamos español (idioma original de los textos).
  // function idiomaTienda(doc) {
  //   function norm(l) { return (l || '').slice(0, 2).toLowerCase(); }
  //   const idiomas = ['es', 'en', 'pt', 'fr'];
  //   let lang = norm(document.documentElement.getAttribute('lang'));
  //   if (idiomas.indexOf(lang) === -1 && doc && doc.documentElement) {
  //     lang = norm(doc.documentElement.getAttribute('lang')); // fallback: idioma del iframe
  //   }
  //   return idiomas.indexOf(lang) !== -1 ? lang : 'es';
  // }
  //
  // // Traduce, dentro del documento del iframe, los textos que el widget deja fijos
  // // en español (ver TRADUCCIONES) al idioma de la tienda. Idempotente: si ya está
  // // en el idioma correcto no hace nada; reconoce el texto en cualquiera de sus
  // // variantes para poder retraducir si el widget lo vuelve a pintar en español.
  // function traducirTextos(doc) {
  //   const idioma = idiomaTienda(doc);
  //   if (idioma === 'es') return; // los textos ya vienen en español
  //   for (let t = 0; t < TRADUCCIONES.length; t++) {
  //     const trad = TRADUCCIONES[t];
  //     const objetivo = trad[idioma];
  //     if (!objetivo) continue;
  //     const variantes = [trad.es, trad.en, trad.pt, trad.fr];
  //     // Solo tocamos elementos de TEXTO PURO (sin hijos) cuyo texto coincida
  //     // exactamente con alguna variante: así no rompemos contenedores ni tocamos
  //     // nada que no sea esa pregunta.
  //     const candidatos = doc.querySelectorAll('.question-text, p, label, span, h1, h2, h3, div');
  //     for (let i = 0; i < candidatos.length; i++) {
  //       const el = candidatos[i];
  //       if (el.children.length > 0) continue;
  //       const txt = (el.textContent || '').trim();
  //       if (txt && txt !== objetivo && variantes.indexOf(txt) !== -1) {
  //         el.textContent = objetivo;
  //       }
  //     }
  //   }
  // }
  /* End MOD */

  // Instala, una sola vez por documento del iframe, los listeners que hacen
  // opcionales el correo y el teléfono, y traducen los textos fijos en español. El
  // observer principal de la página sólo ve el iframe; aquí trabajamos ya DENTRO de
  // su documento (SPA Vue).
  function observarFormulario(iframe) {
    let doc;
    try {
      doc = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);
    } catch (e) {
      return; // cross-origin: sin acceso
    }
    if (!doc || !doc.body) return;
    if (doc.soymodFormObs) return; // ya instalado en ESTE documento
    doc.soymodFormObs = true;

    const win = doc.defaultView || window;

    // 1) Click EXCLUSIVAMENTE sobre el botón "Reservar ahora", en FASE DE CAPTURA
    //    (antes que el handler de Vue): rellenamos los vacíos para que la
    //    validación del envío vea correo y teléfono con valor. Comprobamos que el
    //    click caiga DENTRO del propio botón; clicar el hueco vacío de la barra (que
    //    ocupa todo el ancho) al hacer focus-out NO debe rellenar nada.
    doc.addEventListener('click', function (e) {
      const boton = buscarBotonReservar(doc);
      if (!boton || !e.target || !boton.contains(e.target)) return;
      rellenarVaciosParaEnvio(doc);
    }, true);

    // 2) Al escribir o borrar en cualquier campo, reevaluamos el estado del botón.
    //    setTimeout para ejecutarnos DESPUÉS de que Vue repinte.
    doc.addEventListener('input', function () {
      win.setTimeout(function () { actualizarBoton(doc); }, 0);
    }, true);

    // 3) Y ante cualquier cambio del DOM interno (cambios de pantalla del widget),
    //    reevaluamos el estado del botón y traducimos los textos fijos.
    const Obs = win.MutationObserver || MutationObserver;
    const obs = new Obs(function () {
      actualizarBoton(doc);
      // traducirTextos(doc); /* SOYMOD #103773 (01/07/2026) (3/4) - desactivada la traducción (ver bloque arriba) */
    });
    obs.observe(doc.body, { childList: true, subtree: true });

    actualizarBoton(doc);   // evaluación inmediata por si la pantalla ya está
    // traducirTextos(doc); /* SOYMOD #103773 (01/07/2026) (4/4) - desactivada la traducción (ver bloque arriba) */
  }

  /* End MOD */

  // Busca el iframe en el DOM; si está, lo procesa. Devuelve el elemento (o null).
  function buscarIframe() {
    const iframe = document.querySelector(IFRAME_SELECTOR);
    if (iframe) procesarIframe(iframe);
    return iframe;
  }

  // 1. ¿Ya existe el iframe al ejecutarse el script?
  buscarIframe();

  // 2. Observamos el DOM por si el iframe se inyecta (o se recrea) por JS. No
  //    desconectamos: si el widget destruye y recrea el iframe, lo recogeremos
  //    de nuevo (el guard dataset.soymodObservado evita listeners duplicados).
  const observer = new MutationObserver(function () {
    buscarIframe();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
/* End MOD */